// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__dwMGX","txCreatorAmountCell":"sidebar_txCreatorAmountCell__2ENUN"};